<div class="quantity-wrapper">
  <div class="input-group-prepend w-100">
    <label *ngIf="!!label" [for]="'quantity' + randId" [ngClass]="[needsOverlay ? 'overlay': 'primary-bg-color', isInOrderTree ? 'custom-height' : 'h-auto']" class="form-control quantity-label input-group-text"><span class="sr-only">{{'component.quantities.quantity_options' | translate}}</span>{{label}}</label>
  </div>
  <input #quantity [id]="'quantity' + randId" type="text" [textMask]="{mask: quantityMask}" [disabled]='disabled'
  [ngClass]="[needsOverlay ? 'overlay' : 'primary-bg-color',  label ? 'no-left-border' : '', isInOrderTree ? 'custom-height' : 'h-auto']"
    class="form-control quantity-input" [ngModel]="selectedQuantity" (input)="onQuantityChanged(quantity.value)"
    [attr.aria-describedby]="!!describedBy ? describedBy : (showMinWarning ? (randId + '-error') : undefined)"
  [attr.aria-label]="'component.quantities.quantity_options' | translate" (focusout)="checkValueAfterFocusOut(quantity.value)">

  <div  container="body" ngbDropdown (openChange)="openStatusChanged($event)" class="d-inline-block">
    <button #dropDownArrow [ngClass]="[needsOverlay ? 'overlay': 'primary-bg-color', isInOrderTree ? 'custom-height ' : 'h-auto']" [disabled]="disabled"
            class="btn primary-text-color form-border" [id]="randId" ngbDropdownToggle aria-label="quantity selection dropdown"></button>
    <div ngbDropdownMenu [attr.aria-labelledby]="randId" class="dropdown-wrapper">
      <button (click)="onQuantityChanged(quantity)" ngbDropdownItem 
              *ngFor="let quantity of quantities"
              [ngClass]="(minimumQuantity > 1) ? 'text-left' : 'text-center'"
              [disabled]="quantity < minimumQuantity"
              data-ngb-dropdown-item="true">{{quantity + (quantity < minimumQuantity ? ('component.quantities.not_available' | translate) : '')}}</button>
    </div>
  </div>
</div>
<div class="position-relative">
  <div *ngIf="showMinWarning" id="{{randId}}-error" [@expanded]="{value: showMinWarning, params: {speed: '100ms'}}" class="alert alert-danger position-absolute min-warning" 
       translate [translateParams]="{minQuantity: minimumQuantity}">component.quantities.min_warning</div>
</div>
